import eyeIcon from './../Assets/icons/eye 1.svg'
import editIcon from './../Assets/icons/Un-Checkbox.svg'

export const TABLE_HEADERS = [
    // "Sr No.",
    "No of Wheels",
    "Description",
    "Status",
    "Action"
  ];
  
  export const TABLE_DATA = [
    { id: 1, name: "Meters", description:"lorem ipsum",status: "Active", actions: "Edit/Delete" },
    { id: 2, name: "Kilogram", description:"lorem ipsum",  status: "Inactive", actions: "Edit/Delete" },
    { id: 3, name: "Kilometers", description:"lorem ipsum",  status: "Active", actions: "Edit/Delete" },
  ];
  
  export const keyMapping = {
    // "Sr No.": "Sr No.",
    "No of Wheels": "no_of_wheel",
    "Description":"wheel_desc",    
    "Status": "status",
    "Action": [
        { type: "edit", icon: editIcon, label: "Edit" },
        
      ]
  };